export default "__VITE_ASSET__zLVZ7Q0r__"